import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';

var useValidateField = function useValidateField(validationSchema) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var validateField = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return validationSchema.validate(input, {
                abortEarly: false
              }).then(function () {
                return;
              })["catch"](function (validationErrors) {
                return validationErrors;
              })["finally"](function () {
                setLoading(false);
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function validateField(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    validateField: validateField,
    loading: loading
  };
};

export { useValidateField };